import axios from 'axios';
import {history} from '../store';
import {routeName} from '../Service/env';
import {ws} from "../App";
let axiosI = axios.create({
    // baseURL: 'http://apidevelopment.ubme.com/MenumamaService.svc/web/',
    baseURL: 'https://ubme.net/MenumamaService.svc/Web/',
});
axiosI.interceptors.request.use(function(config) {
    const token = localStorage.getItem('token');
    if ( token !== null ) {
        config.headers.Authorization = token;
    }
    return config;
}, function(err) {
    return Promise.reject(err);
});
axiosI.interceptors.response.use((config)=>{
  if(localStorage.length > 0) {
    if(config.data.results.Message === "Authentication Fail") {
        ws.json({
            type:"disconnect",
            userId:localStorage.getItem('UserId'),
            tokenId:localStorage.getItem('token')
        });
        localStorage.clear();
        clearInterval(window.interval);
        history.push(`/${routeName}`);
    }
    else {
      return config;
    }
  }
  return config;
});
export default axiosI;
